import {
	ApiClient,
	materializeResponseHook,
	platformService,
} from '@monthio/react-components'

const authHook = (request: Request) =>
	request.headers.set(
		'Authorization',
		`Bearer ${platformService.getAccessToken()}`,
	)

const commonConfigs = {
	headers: { 'content-type': 'application/json' },
	hooks: {
		beforeRequest: [authHook],
		beforeError: [materializeResponseHook],
	},
}

export const budgetApiClient = new ApiClient({
	...commonConfigs,
	baseUrl: `${platformService.getAppUrl('budgetApp')}/api`,
	loggerName: 'budgetAppApi',
})

export const transactionApiClient = new ApiClient({
	...commonConfigs,
	baseUrl: `${platformService.getAppUrl('transactionApp')}/api`,
	loggerName: `transactionAppApi`,
})

export const statisticsReportApi = new ApiClient({
	...commonConfigs,
	baseUrl: `${platformService.getAppUrl('statisticsReportApp')}/api`,
	loggerName: `statisticsReportAppApi`,
})

export const pensionApiClient = new ApiClient({
	...commonConfigs,
	baseUrl: `${platformService.getAppUrl('pensionApp')}/api`,
	loggerName: 'pensionAppApi',
})

export const psd2ProxyApi = (url: string) =>
	new ApiClient({
		...commonConfigs,
		baseUrl: `${url}/api`,
		loggerName: `transactionAppApi`,
	})
